/**
 * External Imports
 */
import styled, { css } from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuAvatar, NeuCard, NeuInput, NeuTextarea } from '@neutron/react';

interface IModalFooterProps {
  right?: boolean;
}

export const ProvisioningCard = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  position: relative;
  background: #f6f6f6 !important;
  z-index: 10;
  padding-inline-start: 0;
  padding-inline-end: 0;
  padding-top: 0;
  padding-bottom: 0;
  margin-inline-end: 0;
  margin-top: 0;
  width: 26em;
`;

export const CardHeader = styled(NeuCard)`
  display: flex !important;
  flex-direction: row !important;
  justify-content: space-between !important;
  align-items: center !important;
  padding-top: var(--card-spacing);
  padding-right: var(--card-spacing);
  padding-bottom: var(--card-spacing);
  padding-left: var(--card-spacing);
  height: 56px;
  width: 100%;
`;

export const ModalCardContent = styled(NeuCard)`
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  scroll-behavior: smooth;
`;

export const InputHeading = styled.div`
  display: inline-block;
  font-size: 0.9375rem;
  line-height: 22px;
  margin-top: 12px;
`;

export const ModalInput = styled(NeuInput)`
  height: 42px;
`;

export const ModalFooter = styled(NeuCard)<IModalFooterProps>`
  background: white !important;
  bottom: 0;
  height: 69px !important;
  ${props =>
    !props.right &&
    css`
      display: flex !important;
      justify-content: space-between !important;
    `}
`;

export const UserInfoCard = styled(NeuCard)`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  overflow-wrap: anywhere;
  padding-left: 0;
  padding-right: 0;
`;

export const Avatar = styled(NeuAvatar)`
  width: 100px;
  height: 100px;
`;

export const UserInfoAvatar = styled(NeuCard)`
  display: flex;
  flex-direction: row;
  width: 100px;
`;

export const UserInfoContent = styled(NeuCard)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const UserInfoName = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  color: #686868;
`;

export const UserInfoDetails = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #686868;
`;

export const TitleSpan = styled.span`
  display: flex;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
`;

export const ModalTitle = styled.span`
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 26px;
  color: #06173d;
  width: 280px;
`;
